import axios from 'axios';

import settings from '../libs/config';
import Logger from '../functions/logging';
import ApiError from './apiError.js';
import { isNumber } from '../functions/utils';

const endpoint = settings.api_host + "/group/get";
const endpointGroupDeep = settings.api_host + "/group/deep";
const endpointGroupSVOD = settings.api_host + "/group/svod";
const endpointGroupPanelSegment = settings.api_host + "/group/panelsegment";
const endpointGroupJoin = settings.api_host + "/group/join";
const endpointGroupSubscribe = settings.api_host + "/user/subscribe";
const endpointNDAPrompt = settings.api_host + "/group/ndaprompt";

export const getGroup = async (group_id) => {
	if (!group_id) {
		throw new Error("Missing Group ID");
	}

	// Logger.log(this.constructor.name, "getGroup()", endpoint);

	try {
		const response = await axios.get(endpoint, {
			params: {
				group_id
			}
		});

		// Logger.log(this.constructor.name, "getGroup() response", response);

		const data = response.data;
		return data.result;
	} catch (error) {
		throw new ApiError(error);
	}
};

export const getDeepGroup = async (group_id, ps, user_token) => {
	if (!group_id) throw new Error("Missing Group ID");
	if (!ps && ps !== 0) throw new Error("Missing Panel Segment");
	if (!user_token) throw new Error("Missing User Token");

	try {
		const response = await axios.get(endpointGroupDeep, {
			params: {
				group_id,
				ps,
				user_token
			}
		});

		const data = response.data;
		return data.result;
	} catch (error) {
		throw new ApiError(error);
	}
};

export const getSVODGroup = async (group_id, ps, user_token) => {
	if (!group_id) throw new Error("Missing Group ID");
	if (!ps && ps !== 0) throw new Error("Missing Panel Segment");
	if (!user_token) throw new Error("Missing User Token");

	try {
		const response = await axios.get(endpointGroupSVOD, {
			params: {
				group_id,
				ps,
				user_token
			}
		});

		const data = response.data;
		return data.result;
	} catch (error) {
		throw new ApiError(error);
	}
};

export const getGroupPanelSegment = async (group_id, hhi, age, gender, device, region, provider, ethnicityParams, user_token, panel_segment, isTester, required) => {
	Logger.log(this.constructor.name, "getGroupPanelSegment()", group_id, hhi, age, gender, device, region, provider, ethnicityParams, user_token, panel_segment, isTester, required);

	if (!group_id) throw new Error("Missing Group ID");
	if (!age) throw new Error("Missing Age");
	if (!device) throw new Error("Missing Device Info");
	if (!user_token) throw new Error("Missing User Token Info");

	let params = { group_id: group_id, device: device, user_token: user_token};
	if (age) params.age = age;
	if (hhi) params.hhi = hhi;
	if (gender) params.gender = gender;
	if (region) params.region = region;
	if (provider) params.provider = provider;
	if (ethnicityParams) params.ethnicityParams = ethnicityParams;
	if (isNumber(panel_segment)) params.ps = parseInt(panel_segment);
	if (isTester) params.test = 1;
	if (required) params.required = required;

	Logger.log(this.constructor.name, "getGroupPanelSegment() params", params);

	try {
		const response = await axios.get(endpointGroupPanelSegment, {
			params: params
		});

		const data = response.data;
		return data.result;
	} catch (error) {
		throw new ApiError(error);
	}
};

export const groupJoinSubscription = async (user_token, user_id, video_id, group_id, panel_segment, language_code, screened, screen_code, isTester, skipActionUpdate, browser, device) => {
	if (!user_token) throw new Error("Missing User Token");
	if (!user_id) throw new Error("Missing User ID");
	if (!video_id) throw new Error("Missing Video ID");
	if (!group_id) throw new Error("Missing Group ID");
	if (!isNumber(panel_segment)) throw new Error("Missing Panel Segment Index");
	
	let params = { user_token, user_id, video_id, group_id, panel_segment, language_code, screened, screen_code, browser, device };
	if (isTester) params.test = 1;
	if (skipActionUpdate) params.skip_action_update = true;
	
	try {
		const response = await axios.get(endpointGroupJoin, {
			params: params
		});

		const data = response.data;
		return data.result;
	}
	catch (error) {
		throw new ApiError(error);
	}
};

export const groupSubscribe = async (user_token, user_id, video_id, group_id, panel_segment, language_code, screened, screen_code, isTester, skipActionUpdate, browser, device) => {
	if (!user_token) throw new Error("Missing User Token");
	if (!user_id) throw new Error("Missing User ID");
	// if (!video_id) throw new Error("Missing Video ID");
	const videoId = video_id ? video_id : "temp";
	if (!group_id) throw new Error("Missing Group ID");
	if (!isNumber(panel_segment)) throw new Error("Missing Panel Segment Index");

	let params = { user_token, user_id, video_id: videoId, group_id, panel_segment, language_code, screened, screen_code, browser, device };
	if (isTester) params.test = 1;
	if (skipActionUpdate) params.skip_action_update = true;

	try {
		const response = await axios.get(endpointGroupSubscribe, {
			params: params
		});

		return response.data.result;
	}
	catch (error) {
		throw new ApiError(error);
	}
};

export const getNDAPrompt = async (group_id, ps, user_token) => {
	if (!group_id) throw new Error("Missing Group ID");
	if (!user_token) throw new Error("Missing User Token");

	try {
		const response = await axios.get(endpointNDAPrompt, {
			params: {
				group_id,
				ps,
				user_token
			}
		});

		const data = response.data;
		return data.result;
	} 
	catch (error) {
		throw new ApiError(error);
	}
};


// WEBPACK FOOTER //
// ./src/api/group.js